import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class InvitationService {

    constructor(private http: HttpClient) {
    }

    async inviteMember(email: string, addPlaceholderToTeam: boolean): Promise<void> {
        return this.http
            .post<void>(`/api/invitations`, {
                email,
                addPlaceholderToTeam
            }).toPromise();
    }
}
